var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.667,
    height: 24.667,
    viewBox: "0 0 24.667 24.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M15.708,3.375A12.333,12.333,0,1,0,28.042,15.708,12.331,12.331,0,0,0,15.708,3.375ZM22.023,12.3,14.1,20.262H14.09a1.071,1.071,0,0,1-.688.326,1.038,1.038,0,0,1-.694-.338L9.388,16.93a.236.236,0,0,1,0-.338l1.055-1.055a.229.229,0,0,1,.332,0l2.633,2.633,7.234-7.287a.234.234,0,0,1,.166-.071h0a.215.215,0,0,1,.166.071l1.038,1.073A.234.234,0,0,1,22.023,12.3Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#27c484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.08999772273e3d2736f62a99a77ff9e7.svg";
export { ForwardRef as ReactComponent };